export default __webpack_public_path__ + "static/media/slider_0.183d23cd.jpg";